/* eslint-disable */
import { api } from './../../api.js';
import {vue_instance} from "../../main";
//import api_routes from './../../api_routes.js';

const state = {
};

const getters = {

}

const mutations = {
}

const actions = {
    getOffers : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('offers', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    deleteOffer : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.delete('offers/' + data.id, {}).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    deleteAllOffers : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.delete('offers', {}).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    getOfferCountries : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('offers/select', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    addOffer : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.post('offers', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    editOffer : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.patch('offers/' + data.id, data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
}

export default {
    state,
    actions,
    getters,
    mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/OffersModule.js